import { apiFetch, ApiError } from './api';
import { clearTokens, getRefreshToken, setAccessToken, setRefreshToken } from './tokenStorage';

export interface AuthUser {
  id: string;
  email: string;
  nombre: string | null;
}

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: AuthUser;
}

export async function login(email: string, password: string): Promise<AuthUser> {
  const data = await apiFetch<LoginResponse>('/auth/login', {
    method: 'POST',
    body: { email, password },
    intentarRefresh: false,
  });
  setAccessToken(data.accessToken);
  await setRefreshToken(data.refreshToken);
  return data.user;
}

export async function logout(): Promise<void> {
  const refreshToken = await getRefreshToken();
  if (refreshToken) {
    try {
      await apiFetch<void>('/auth/logout', {
        method: 'POST',
        body: { refreshToken },
        intentarRefresh: false,
      });
    } catch {
      // best-effort; igual limpiamos tokens locales
    }
  }
  await clearTokens();
}

/**
 * Lee al usuario actual. Distingue entre:
 * - null + sin throw: no hay sesión activa (401).
 * - throw: la API es alcanzable pero respondió un error que el llamador
 *   debe manejar (ej. 429 rate limit, 5xx). NO implica logout.
 */
export async function obtenerUsuarioActual(): Promise<AuthUser | null> {
  try {
    return await apiFetch<AuthUser>('/auth/me');
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) return null;
    throw e;
  }
}
